<template>
  <b-container
    fluid
    class="h-100 p-0 d-flex justify-content-center"
    id="errorBody"
  >
    <b-row align-v="center" align-h="center">
      <b-col class="shadow-sm p-5 bg-white rounded-sm">
        <div class="text-primary display-2">
          <span class="font-weight-bolder">404</span
          ><img src="/img/panda-repare.png" />
        </div>
        <div id="message" class="mb-4 mr-2 pt-3 pb-3 font-weight-light">
          {{ "errorPage.message" | i18n }}
        </div>
        <router-link id="home" to="/">
          <button
            class="bg-primary text-white shadow-sm rounded-sm p-2 mb-4 border-0"
          >
            {{ "errorPage.accueil" | i18n }}
          </button></router-link
        >
      </b-col>
    </b-row>
  </b-container>
</template>
<script scoped>
/**
 * @description Vue de la page 404. Quand l'utilisateur tape un lien incorrect, il est redirigé sur la 404.
 * @author Francine Jin
 */
export default {
  name: "Error404"
};
</script>
<style scoped lang="scss">
#errorBody {
  background-image: url("../../public/img/login-background.jpg");
  background-size: 100% 50%;
  background-repeat: no-repeat;
}

img {
  height: 90px;
  margin-bottom: 20px;
}

@media screen and (max-width: 1025px) {
  #errorBody {
    width: unset !important;
  }
}

@media screen and (max-width: 414px) {
  #errorBody {
    overflow: hidden;
  }
  img {
    height: 70px;
    margin-bottom: 20px;
  }
  #message {
    margin-bottom: 5% !important;
  }
  #foot {
    position: absolute !important;
  }
}
</style>
